import React from 'react'
import ImagePickerModal from './ImagePickerModal'
import { url } from '../../utils/variables';
import { useSelector } from 'react-redux';

function ImageBox({title,name,label,attachments,uploadDoc,disableGallery}) {
    const {insuranceCode} = useSelector(store=>store)
    function renderButton(name) {
        const image = attachments.find(img => img.filename === name);
        return (
            image ?
            <img className='my10' src={`${url}/files?uid=${image.uid}&width=85&height=60`} alt='img'/> :
            'default'
        )
    }
  return (
    <div className='upload-parent'>
        <div className='upload-text'>
            {insuranceCode === 'l9Rx6eo2' && <span className='required-icon'>* </span>}
            {title}
        </div>
        <ImagePickerModal
            disableGallery={disableGallery}
            renderBtn={renderButton(name, title)}
            upload={(image, done) => uploadDoc(image, name, done)}
            label={label}
            imageUid={attachments.find(itm => itm.filename === name)}
        />
    </div>
  )
}

export default ImageBox